import { http, setHTTPHeader } from '@/services/http.service'
import type { IUserLogin, IRegisterUser } from '@/types/auth'

export const loginApi = (user: IUserLogin) =>
  http.post('/users/login', { user })

export const logoutApi = () =>
  http.delete('/users/logout')

export const registerApi = (user: IRegisterUser) =>
  http.post('/users/signup', { user })

export const forgotPasswordApi = (data: { email: string }) =>
  http.put('/api/v1/users/reset_password', data)

export const resetPasswordApi = (data: { password: string; token: string }) =>
  http.put('/api/v1/users/reset_password_confirmation', data)

export const fetchCurrentUserApi = () =>
  http.get('/api/v1/users/connected_user')

export const updateUserApi = (id: number, data: FormData | Record<string, unknown>) =>
  http.patch(`/api/v1/users/${id}`, data)

export const changePasswordApi = (
  id: number,
  data: { current_password: string; password: string; password_confirmation: string },
) => http.put(`/api/v1/users/${id}/change_password`, data)

// Call after login to persist token
export const setAuthHeader = (token: string) => {
  setHTTPHeader({ Authorization: token })
}

export const verifyOtpApi = (data: { pre_auth_token: string; otp_code: string }) =>
  http.post('/api/v1/two_factor/verify', data)

export const enableTwoFactorApi = (data: { current_password: string }) =>
  http.post('/api/v1/two_factor/enable', data)

export const disableTwoFactorApi = (data: { current_password: string }) =>
  http.delete('/api/v1/two_factor/disable', { data })

export const trustDeviceApi = () =>
  http.post('/api/v1/trusted_devices')
